module.exports = __webpack_public_path__ + "fonts/check.18095c38241c098a1587.svg";